<template>
    <form class="advanced-search">
        <h1 class="advanced-search__title" v-if="!type">Advanced Search<span>powered by Google</span></h1>
        <div class="has-margin-t30" id="search-results" v-html="googleCustomSearchResults"></div>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import selector from '../elements/Selector.vue';

    export default {
        components: {
            selector
        },
        created: function () {
            eventBus.$on('bbrc-as-fr', this.updateSearchResults);
            this.init();
        },
        destroyed: function () {
            eventBus.$off('bbrc-as-fr', this.updateSearchResults);
        },
        data: function () {
            return {
                loadCounter: 0,
                activeOptionTab: 'country',
                activeFileTypeTab: 'popular',
                activeTab: 'search',
                allTheseWords: '',
                anyOfTheseWords: '',
                country: null,
                countries: [
                    { name : "Afghanistan", icon : "flags/af.png", value : "af" },
                    { name : "Albania", icon : "flags/al.png", value : "al" },
                    { name : "Algeria", icon : "flags/dz.png", value : "dz" },
                    { name : "American Samoa", icon : "flags/as.png", value : "as" },
                    { name : "Andorra", icon : "flags/ad.png", value : "ad" },
                    { name : "Angola", icon : "flags/ao.png", value : "ao" },
                    { name : "Anguilla", icon : "flags/ai.png", value : "ai" },
                    { name : "Antarctica", icon : "flags/aq.png", value : "aq" },
                    { name : "Antigua and Barbuda", icon : "flags/ag.png", value : "ag" },
                    { name : "Argentina", icon : "flags/ar.png", value : "ar" },
                    { name : "Armenia", icon : "flags/am.png", value : "am" },
                    { name : "Aruba", icon : "flags/aw.png", value : "aw" },
                    { name : "Australia", icon : "flags/au.png", value : "au" },
                    { name : "Austria", icon : "flags/at.png", value : "at" },
                    { name : "Azerbaijan", icon : "flags/az.png", value : "az" },
                    { name : "Bahamas", icon : "flags/bs.png", value : "bs" },
                    { name : "Bahrain", icon : "flags/bh.png", value : "bh" },
                    { name : "Bangladesh", icon : "flags/bd.png", value : "bd" },
                    { name : "Barbados", icon : "flags/bb.png", value : "bb" },
                    { name : "Belarus", icon : "flags/by.png", value : "by" },
                    { name : "Belgium", icon : "flags/be.png", value : "be" },
                    { name : "Belize", icon : "flags/bz.png", value : "bz" },
                    { name : "Benin", icon : "flags/bj.png", value : "bj" },
                    { name : "Bermuda", icon : "flags/bm.png", value : "bm" },
                    { name : "Bhutan", icon : "flags/bt.png", value : "bt" },
                    { name : "Bolivia", icon : "flags/bo.png", value : "bo" },
                    { name : "Bosnia and Herzegovina", icon : "flags/ba.png", value : "ba" },
                    { name : "Botswana", icon : "flags/bw.png", value : "bw" },
                    { name : "Bouvet Island", icon : "flags/bv.png", value : "bv" },
                    { name : "Brazil", icon : "flags/br.png", value : "br" },
                    { name : "British Indian Ocean Territory", icon : "flags/io.png", value : "io" },
                    { name : "Brunei Darussalam", icon : "flags/bn.png", value : "bn" },
                    { name : "Bulgaria", icon : "flags/bg.png", value : "bg" },
                    { name : "Burkina Faso", icon : "flags/bf.png", value : "bf" },
                    { name : "Burundi", icon : "flags/bi.png", value : "bi" },
                    { name : "Cabo Verde", icon : "flags/cv.png", value : "cv" },
                    { name : "Cambodia", icon : "flags/kh.png", value : "kh" },
                    { name : "Cameroon", icon : "flags/cm.png", value : "cm" },
                    { name : "Canada", icon : "flags/ca.png", value : "ca" },
                    { name : "Cayman Islands", icon : "flags/ky.png", value : "ky" },
                    { name : "Central African Republic", icon : "flags/cf.png", value : "cf" },
                    { name : "Chad", icon : "flags/td.png", value : "td" },
                    { name : "Chile", icon : "flags/cl.png", value : "cl" },
                    { name : "China", icon : "flags/cn.png", value : "cn" },
                    { name : "Christmas Island", icon : "flags/cx.png", value : "cx" },
                    { name : "Cocos (Keeling) Islands", icon : "flags/cc.png", value : "cc" },
                    { name : "Colombia", icon : "flags/co.png", value : "co" },
                    { name : "Comoros", icon : "flags/km.png", value : "km" },
                    { name : "Congo", icon : "flags/cg.png", value : "cg" },
                    { name : "Congo, Democratic Republic of the", icon : "flags/cd.png", value : "cd" },
                    { name : "Cook Islands", icon : "flags/ck.png", value : "ck" },
                    { name : "Costa Rica", icon : "flags/cr.png", value : "cr" },
                    { name : "Côte d'Ivoire", icon : "flags/ci.png", value : "ci" },
                    { name : "Croatia", icon : "flags/hr.png", value : "hr" },
                    { name : "Cuba", icon : "flags/cu.png", value : "cu" },
                    { name : "Curaçao", icon : "flags/cw.png", value : "cw" },
                    { name : "Cyprus", icon : "flags/cy.png", value : "cy" },
                    { name : "Czechia", icon : "flags/cz.png", value : "cz" },
                    { name : "Denmark", icon : "flags/dk.png", value : "dk" },
                    { name : "Djibouti", icon : "flags/dj.png", value : "dj" },
                    { name : "Dominica", icon : "flags/dm.png", value : "dm" },
                    { name : "Dominican Republic", icon : "flags/do.png", value : "do" },
                    { name : "Ecuador", icon : "flags/ec.png", value : "ec" },
                    { name : "Egypt", icon : "flags/eg.png", value : "eg" },
                    { name : "El Salvador", icon : "flags/sv.png", value : "sv" },
                    { name : "Equatorial Guinea", icon : "flags/gq.png", value : "gq" },
                    { name : "Eritrea", icon : "flags/er.png", value : "er" },
                    { name : "Estonia", icon : "flags/ee.png", value : "ee" },
                    { name : "Eswatini", icon : "flags/sz.png", value : "sz" },
                    { name : "Ethiopia", icon : "flags/et.png", value : "et" },
                    { name : "Falkland Islands (Malvinas)", icon : "flags/fk.png", value : "fk" },
                    { name : "Faroe Islands", icon : "flags/fo.png", value : "fo" },
                    { name : "Fiji", icon : "flags/fj.png", value : "fj" },
                    { name : "Finland", icon : "flags/fi.png", value : "fi" },
                    { name : "France", icon : "flags/fr.png", value : "fr" },
                    { name : "French Guiana", icon : "flags/gf.png", value : "gf" },
                    { name : "French Polynesia", icon : "flags/pf.png", value : "pf" },
                    { name : "French Southern Territories", icon : "flags/tf.png", value : "tf" },
                    { name : "Gabon", icon : "flags/ga.png", value : "ga" },
                    { name : "Gambia", icon : "flags/gm.png", value : "gm" },
                    { name : "Georgia", icon : "flags/ge.png", value : "ge" },
                    { name : "Germany", icon : "flags/de.png", value : "de" },
                    { name : "Ghana", icon : "flags/gh.png", value : "gh" },
                    { name : "Gibraltar", icon : "flags/gi.png", value : "gi" },
                    { name : "Greece", icon : "flags/gr.png", value : "gr" },
                    { name : "Greenland", icon : "flags/gl.png", value : "gl" },
                    { name : "Grenada", icon : "flags/gd.png", value : "gd" },
                    { name : "Guadeloupe", icon : "flags/gp.png", value : "gp" },
                    { name : "Guam", icon : "flags/gu.png", value : "gu" },
                    { name : "Guatemala", icon : "flags/gt.png", value : "gt" },
                    { name : "Guernsey", icon : "flags/gg.png", value : "gg" },
                    { name : "Guinea", icon : "flags/gn.png", value : "gn" },
                    { name : "Guinea-Bissau", icon : "flags/gw.png", value : "gw" },
                    { name : "Guyana", icon : "flags/gy.png", value : "gy" },
                    { name : "Haiti", icon : "flags/ht.png", value : "ht" },
                    { name : "Heard Island and McDonald Islands", icon : "flags/hm.png", value : "hm" },
                    { name : "Holy See", icon : "flags/va.png", value : "va" },
                    { name : "Honduras", icon : "flags/hn.png", value : "hn" },
                    { name : "Hong Kong", icon : "flags/hk.png", value : "hk" },
                    { name : "Hungary", icon : "flags/hu.png", value : "hu" },
                    { name : "Iceland", icon : "flags/is.png", value : "is" },
                    { name : "India", icon : "flags/in.png", value : "in" },
                    { name : "Indonesia", icon : "flags/id.png", value : "id" },
                    { name : "Iran, Islamic Republic of", icon : "flags/ir.png", value : "ir" },
                    { name : "Iraq", icon : "flags/iq.png", value : "iq" },
                    { name : "Ireland", icon : "flags/ie.png", value : "ie" },
                    { name : "Israel", icon : "flags/il.png", value : "il" },
                    { name : "Italy", icon : "flags/it.png", value : "it" },
                    { name : "Jamaica", icon : "flags/jm.png", value : "jm" },
                    { name : "Japan", icon : "flags/jp.png", value : "jp" },
                    { name : "Jordan", icon : "flags/jo.png", value : "jo" },
                    { name : "Kazakhstan", icon : "flags/kz.png", value : "kz" },
                    { name : "Kenya", icon : "flags/ke.png", value : "ke" },
                    { name : "Kiribati", icon : "flags/ki.png", value : "ki" },
                    { name : "Korea, Democratic People's Republic of", icon : "flags/kp.png", value : "kp" },
                    { name : "Korea, Republic of", icon : "flags/kr.png", value : "kr" },
                    { name : "Kuwait", icon : "flags/kw.png", value : "kw" },
                    { name : "Kyrgyzstan", icon : "flags/kg.png", value : "kg" },
                    { name : "Lao People's Democratic Republic", icon : "flags/la.png", value : "la" },
                    { name : "Latvia", icon : "flags/lv.png", value : "lv" },
                    { name : "Lebanon", icon : "flags/lb.png", value : "lb" },
                    { name : "Lesotho", icon : "flags/ls.png", value : "ls" },
                    { name : "Liberia", icon : "flags/lr.png", value : "lr" },
                    { name : "Libya", icon : "flags/ly.png", value : "ly" },
                    { name : "Liechtenstein", icon : "flags/li.png", value : "li" },
                    { name : "Lithuania", icon : "flags/lt.png", value : "lt" },
                    { name : "Luxembourg", icon : "flags/lu.png", value : "lu" },
                    { name : "Macao", icon : "flags/mo.png", value : "mo" },
                    { name : "Macedonia, the former Yugoslav Republic of", icon : "flags/mk.png", value : "mk" },
                    { name : "Madagascar", icon : "flags/mg.png", value : "mg" },
                    { name : "Malawi", icon : "flags/mw.png", value : "mw" },
                    { name : "Malaysia", icon : "flags/my.png", value : "my" },
                    { name : "Maldives", icon : "flags/mv.png", value : "mv" },
                    { name : "Mali", icon : "flags/ml.png", value : "ml" },
                    { name : "Malta", icon : "flags/mt.png", value : "mt" },
                    { name : "Marshall Islands", icon : "flags/mh.png", value : "mh" },
                    { name : "Martinique", icon : "flags/mq.png", value : "mq" },
                    { name : "Mauritania", icon : "flags/mr.png", value : "mr" },
                    { name : "Mauritius", icon : "flags/mu.png", value : "mu" },
                    { name : "Mayotte", icon : "flags/yt.png", value : "yt" },
                    { name : "Mexico", icon : "flags/mx.png", value : "mx" },
                    { name : "Micronesia, Federated States of", icon : "flags/fm.png", value : "fm" },
                    { name : "Moldova, Republic of", icon : "flags/md.png", value : "md" },
                    { name : "Monaco", icon : "flags/mc.png", value : "mc" },
                    { name : "Mongolia", icon : "flags/mn.png", value : "mn" },
                    { name : "Montenegro", icon : "flags/me.png", value : "me" },
                    { name : "Montserrat", icon : "flags/ms.png", value : "ms" },
                    { name : "Morocco", icon : "flags/ma.png", value : "ma" },
                    { name : "Mozambique", icon : "flags/mz.png", value : "mz" },
                    { name : "Myanmar", icon : "flags/mm.png", value : "mm" },
                    { name : "Namibia", icon : "flags/na.png", value : "na" },
                    { name : "Nauru", icon : "flags/nr.png", value : "nr" },
                    { name : "Nepal", icon : "flags/np.png", value : "np" },
                    { name : "Netherlands", icon : "flags/nl.png", value : "nl" },
                    { name : "New Caledonia", icon : "flags/nc.png", value : "nc" },
                    { name : "New Zealand", icon : "flags/nz.png", value : "nz" },
                    { name : "Nicaragua", icon : "flags/ni.png", value : "ni" },
                    { name : "Niger", icon : "flags/ne.png", value : "ne" },
                    { name : "Nigeria", icon : "flags/ng.png", value : "ng" },
                    { name : "Niue", icon : "flags/nu.png", value : "nu" },
                    { name : "Norfolk Island", icon : "flags/nf.png", value : "nf" },
                    { name : "Northern Mariana Islands", icon : "flags/mp.png", value : "mp" },
                    { name : "Norway", icon : "flags/no.png", value : "no" },
                    { name : "Oman", icon : "flags/om.png", value : "om" },
                    { name : "Pakistan", icon : "flags/pk.png", value : "pk" },
                    { name : "Palau", icon : "flags/pw.png", value : "pw" },
                    { name : "Palestine, State of", icon : "flags/ps.png", value : "ps" },
                    { name : "Panama", icon : "flags/pa.png", value : "pa" },
                    { name : "Papua New Guinea", icon : "flags/pg.png", value : "pg" },
                    { name : "Paraguay", icon : "flags/py.png", value : "py" },
                    { name : "Peru", icon : "flags/pe.png", value : "pe" },
                    { name : "Philippines", icon : "flags/ph.png", value : "ph" },
                    { name : "Pitcairn", icon : "flags/pn.png", value : "pn" },
                    { name : "Poland", icon : "flags/pl.png", value : "pl" },
                    { name : "Portugal", icon : "flags/pt.png", value : "pt" },
                    { name : "Puerto Rico", icon : "flags/pr.png", value : "pr" },
                    { name : "Qatar", icon : "flags/qa.png", value : "qa" },
                    { name : "Réunion", icon : "flags/re.png", value : "re" },
                    { name : "Romania", icon : "flags/ro.png", value : "ro" },
                    { name : "Russian Federation", icon : "flags/ru.png", value : "ru" },
                    { name : "Rwanda", icon : "flags/rw.png", value : "rw" },
                    { name : "Saint Helena, Ascension and Tristan da Cunha", icon : "flags/sh.png", value : "sh" },
                    { name : "Saint Kitts and Nevis", icon : "flags/kn.png", value : "kn" },
                    { name : "Saint Lucia", icon : "flags/lc.png", value : "lc" },
                    { name : "Saint Pierre and Miquelon", icon : "flags/pm.png", value : "pm" },
                    { name : "Saint Vincent and the Grenadines", icon : "flags/vc.png", value : "vc" },
                    { name : "Samoa", icon : "flags/ws.png", value : "ws" },
                    { name : "San Marino", icon : "flags/sm.png", value : "sm" },
                    { name : "Sao Tome and Principe", icon : "flags/st.png", value : "st" },
                    { name : "Saudi Arabia", icon : "flags/sa.png", value : "sa" },
                    { name : "Senegal", icon : "flags/sn.png", value : "sn" },
                    { name : "Serbia", icon : "flags/rs.png", value : "rs" },
                    { name : "Seychelles", icon : "flags/sc.png", value : "sc" },
                    { name : "Sierra Leone", icon : "flags/sl.png", value : "sl" },
                    { name : "Singapore", icon : "flags/sg.png", value : "sg" },
                    { name : "Slovakia", icon : "flags/sk.png", value : "sk" },
                    { name : "Slovenia", icon : "flags/si.png", value : "si" },
                    { name : "Solomon Islands", icon : "flags/sb.png", value : "sb" },
                    { name : "Somalia", icon : "flags/so.png", value : "so" },
                    { name : "South Africa", icon : "flags/za.png", value : "za" },
                    { name : "South Georgia and the South Sandwich Islands", icon : "flags/gs.png", value : "gs" },
                    { name : "South Sudan", icon : "flags/ss.png", value : "ss" },
                    { name : "Spain", icon : "flags/es.png", value : "es" },
                    { name : "Sri Lanka", icon : "flags/lk.png", value : "lk" },
                    { name : "Sudan", icon : "flags/sd.png", value : "sd" },
                    { name : "Suriname", icon : "flags/sr.png", value : "sr" },
                    { name : "Svalbard and Jan Mayen", icon : "flags/sj.png", value : "sj" },
                    { name : "Sweden", icon : "flags/se.png", value : "se" },
                    { name : "Switzerland", icon : "flags/ch.png", value : "ch" },
                    { name : "Syrian Arab Republic", icon : "flags/sy.png", value : "sy" },
                    { name : "Taiwan, Province of China", icon : "flags/tw.png", value : "tw" },
                    { name : "Tajikistan", icon : "flags/tj.png", value : "tj" },
                    { name : "Tanzania, United Republic of", icon : "flags/tz.png", value : "tz" },
                    { name : "Thailand", icon : "flags/th.png", value : "th" },
                    { name : "Timor-Leste", icon : "flags/tl.png", value : "tl" },
                    { name : "Togo", icon : "flags/tg.png", value : "tg" },
                    { name : "Tokelau", icon : "flags/tk.png", value : "tk" },
                    { name : "Tonga", icon : "flags/to.png", value : "to" },
                    { name : "Trinidad and Tobago", icon : "flags/tt.png", value : "tt" },
                    { name : "Tunisia", icon : "flags/tn.png", value : "tn" },
                    { name : "Turkey", icon : "flags/tr.png", value : "tr" },
                    { name : "Turkmenistan", icon : "flags/tm.png", value : "tm" },
                    { name : "Turks and Caicos Islands", icon : "flags/tc.png", value : "tc" },
                    { name : "Tuvalu", icon : "flags/tv.png", value : "tv" },
                    { name : "Uganda", icon : "flags/ug.png", value : "ug" },
                    { name : "Ukraine", icon : "flags/ua.png", value : "ua" },
                    { name : "United Arab Emirates", icon : "flags/ae.png", value : "ae" },
                    { name : "United Kingdom", icon : "flags/gb.png", value : "uk" },
                    { name : "United States of America", icon : "flags/us.png", value : "us" },
                    { name : "United States Minor Outlying Islands", icon : "flags/um.png", value : "um" },
                    { name : "Uruguay", icon : "flags/uy.png", value : "uy" },
                    { name : "Uzbekistan", icon : "flags/uz.png", value : "uz" },
                    { name : "Vanuatu", icon : "flags/vu.png", value : "vu" },
                    { name : "Venezuela", icon : "flags/ve.png", value : "ve" },
                    { name : "Viet Nam", icon : "flags/vn.png", value : "vn" },
                    { name : "Virgin Islands, British", icon : "flags/vg.png", value : "vg" },
                    { name : "Virgin Islands, U.S.", icon : "flags/vi.png", value : "vi" },
                    { name : "Wallis and Futuna", icon : "flags/wf.png", value : "wf" },
                    { name : "Western Sahara", icon : "flags/eh.png", value : "eh" },
                    { name : "Yemen", icon : "flags/ye.png", value : "ye" },
                    { name : "Zambia", icon : "flags/zm.png", value : "zm" },
                    { name : "Zimbabwe", icon : "flags/zw.png", value : "zw" }
                ],
                filetype: null,
                filetypes: {
                    popular: [
                        {name: 'pdf', icon: null, value: 'pdf'},
                        {name: 'doc', icon: null, value: 'doc'},
                        {name: 'torrent', icon: null, value: 'torrent'},
                        {name: 'jpg', icon: null, value: 'jpg'},
                        {name: 'png', icon: null, value: 'png'},
                        {name: 'gif', icon: null, value: 'gif'},
                        {name: 'ppt', icon: null, value: 'ppt'},
                        {name: 'avi', icon: null, value: 'avi'},
                        {name: 'mp3', icon: null, value: 'mp3'}
                    ],
                    audio: [
                        {name: 'aif', icon: null, value: 'aif'},
                        {name: 'cda', icon: null, value: 'cda'},
                        {name: 'mid/midi', icon: null, value: 'mid/midi'},
                        {name: 'mpa', icon: null, value: 'mpa'},
                        {name: 'mp3', icon: null, value: 'mp3'},
                        {name: 'ogg', icon: null, value: 'ogg'},
                        {name: 'wav', icon: null, value: 'wav'},
                        {name: 'wpl', icon: null, value: 'wpl'}
                    ],
                    video: [
                        {name: '3gp', icon: null, value: '3gp'},
                        {name: 'avi', icon: null, value: 'avi'},
                        {name: 'flv', icon: null, value: 'flv'},
                        {name: 'h264', icon: null, value: 'h264'},
                        {name: 'm4v', icon: null, value: 'm4v'},
                        {name: 'mkv', icon: null, value: 'mkv'},
                        {name: 'mov', icon: null, value: 'mov'},
                        {name: 'mp4', icon: null, value: 'mp4'},
                        {name: 'mpg/mpeg', icon: null, value: 'mpg/mpeg'},
                        {name: 'rm', icon: null, value: 'rm'},
                        {name: 'swf', icon: null, value: 'swf'},
                        {name: 'vob', icon: null, value: 'vob'},
                        {name: 'wmv', icon: null, value: 'wmv'}
                    ],
                    image: [
                        {name: 'ai', icon: null, value: 'ai'},
                        {name: 'bmp', icon: null, value: 'bmp'},
                        {name: 'gif', icon: null, value: 'gif'},
                        {name: 'ico', icon: null, value: 'ico'},
                        {name: 'jpg/jpeg', icon: null, value: 'jpg/jpeg'},
                        {name: 'png', icon: null, value: 'png'},
                        {name: 'ps', icon: null, value: 'ps'},
                        {name: 'psd', icon: null, value: 'psd'},
                        {name: 'svg', icon: null, value: 'svg'},
                        {name: 'tif/tiff', icon: null, value: 'tif/tiff'}
                    ],
                    text: [
                        {name: 'doc/docx', icon: null, value: 'doc/docx'},
                        {name: 'odt', icon: null, value: 'odt'},
                        {name: 'pages', icon: null, value: 'pages'},
                        {name: 'pdf', icon: null, value: 'pdf'},
                        {name: 'rtf', icon: null, value: 'rtf'},
                        {name: 'tex', icon: null, value: 'tex'},
                        {name: 'txt', icon: null, value: 'txt'},
                        {name: 'wks/wps', icon: null, value: 'wks/wps'},
                        {name: 'wpd', icon: null, value: 'wpd'}
                    ],
                    presentation: [
                        {name: 'key', icon: null, value: 'key'},
                        {name: 'odp', icon: null, value: 'odp'},
                        {name: 'pps', icon: null, value: 'pps'},
                        {name: 'ppt', icon: null, value: 'ppt'},
                        {name: 'pptx', icon: null, value: 'pptx'}
                    ],
                    spreadsheet: [
                        {name: 'ods', icon: null, value: 'ods'},
                        {name: 'xlr', icon: null, value: 'xlr'},
                        {name: 'xls', icon: null, value: 'xls'},
                        {name: 'xlsx', icon: null, value: 'xlsx'}
                    ],
                    font: [
                        {name: 'fnt', icon: null, value: 'fnt'},
                        {name: 'fon', icon: null, value: 'fon'},
                        {name: 'ttf', icon: null, value: 'ttf'},
                        {name: 'otf', icon: null, value: 'otf'}
                    ],
                    compressed: [
                        {name: '7z', icon: null, value: '7z'},
                        {name: 'arj', icon: null, value: 'arj'},
                        {name: 'deb', icon: null, value: 'deb'},
                        {name: 'pkg', icon: null, value: 'pkg'},
                        {name: 'rpm', icon: null, value: 'rpm'},
                        {name: 'tar.gz', icon: null, value: 'tar.gz'},
                        {name: 'z', icon: null, value: 'z'},
                        {name: 'zip', icon: null, value: 'zip'},
                        {name: 'rar ', icon: null, value: 'rar'}
                    ],
                    media: [
                        {name: 'bin', icon: null, value: 'bin'},
                        {name: 'dmg', icon: null, value: 'dmg'},
                        {name: 'iso', icon: null, value: 'iso'},
                        {name: 'toast', icon: null, value: 'toast'},
                        {name: 'vcd', icon: null, value: 'vcd'}
                    ],
                    data: [
                        {name: 'csv', icon: null, value: 'csv'},
                        {name: 'dat', icon: null, value: 'dat'},
                        {name: 'db/dbf', icon: null, value: 'db/dbf'},
                        {name: 'log', icon: null, value: 'log'},
                        {name: 'mdb', icon: null, value: 'mdb'},
                        {name: 'sav', icon: null, value: 'sav'},
                        {name: 'sql', icon: null, value: 'sql'},
                        {name: 'tar', icon: null, value: 'tar'},
                        {name: 'xml', icon: null, value: 'xml'}
                    ],
                    internet: [
                        {name: 'asp/aspx', icon: null, value: 'asp/aspx'},
                        {name: 'cer', icon: null, value: 'cer'},
                        {name: 'cfm', icon: null, value: 'cfm'},
                        {name: 'cgi/pl', icon: null, value: 'cgi/pl'},
                        {name: 'css', icon: null, value: 'css'},
                        {name: 'htm/html', icon: null, value: 'htm/html'},
                        {name: 'js', icon: null, value: 'js'},
                        {name: 'jsp', icon: null, value: 'jsp'},
                        {name: 'php', icon: null, value: 'php'},
                        {name: 'py', icon: null, value: 'py'},
                        {name: 'rss', icon: null, value: 'rss'},
                        {name: 'xhtml', icon: null, value: 'xhtml'}
                    ],
                    programming: [
                        {name: 'c', icon: null, value: 'c'},
                        {name: 'class', icon: null, value: 'class'},
                        {name: 'cpp', icon: null, value: 'cpp'},
                        {name: 'cs', icon: null, value: 'cs'},
                        {name: 'h', icon: null, value: 'h'},
                        {name: 'java', icon: null, value: 'java'},
                        {name: 'lua', icon: null, value: 'lua'},
                        {name: 'm', icon: null, value: 'm'},
                        {name: 'pl', icon: null, value: 'pl'},
                        {name: 'py', icon: null, value: 'py'},
                        {name: 'sh', icon: null, value: 'sh'},
                        {name: 'swift', icon: null, value: 'swift'},
                        {name: 'vb', icon: null, value: 'vb'}
                    ],
                    system: [
                        {name: 'bak', icon: null, value: 'bak'},
                        {name: 'cab', icon: null, value: 'cab'},
                        {name: 'cfg', icon: null, value: 'cfg'},
                        {name: 'cpl', icon: null, value: 'cpl'},
                        {name: 'cur', icon: null, value: 'cur'},
                        {name: 'dll', icon: null, value: 'dll'},
                        {name: 'dmp', icon: null, value: 'dmp'},
                        {name: 'drv', icon: null, value: 'drv'},
                        {name: 'icns', icon: null, value: 'icns'},
                        {name: 'ico', icon: null, value: 'ico'},
                        {name: 'ini', icon: null, value: 'ini'},
                        {name: 'lnk', icon: null, value: 'lnk'},
                        {name: 'msi', icon: null, value: 'msi'},
                        {name: 'sys', icon: null, value: 'sys'},
                        {name: 'tmp', icon: null, value: 'tmp'}
                    ],
                    executable: [
                        {name: 'apk', icon: null, value: 'apk'},
                        {name: 'bat', icon: null, value: 'bat'},
                        {name: 'bin', icon: null, value: 'bin'},
                        {name: 'cgi/pl', icon: null, value: 'cgi/pl'},
                        {name: 'com', icon: null, value: 'com'},
                        {name: 'exe', icon: null, value: 'exe'},
                        {name: 'jar', icon: null, value: 'jar'},
                        {name: 'py', icon: null, value: 'py'},
                        {name: 'wsf', icon: null, value: 'wsf'}
                    ]
                },
                filetypeSearch: '',
                googleCustomSearchResults: '<gcse:searchresults-only gname="google-search-results"><\/gcse:searchresults-only>',
                googleTabs: {
                    'books': 'bks',
                    'finance': 'fin',
                    'images': 'isch',
                    'news': 'nws',
                    'patents': 'pts',
                    'shopping': 'shop',
                    'videos': 'vid'
                },
                language: null,
                languages: [
                    { name : "Arabic", icon : null, value : "ar" },
                    { name : "Bulgarian", icon : null, value : "bg" },
                    { name : "Catalan", icon : null, value : "ca" },
                    { name : "Chinese Simplified", icon : null, value : "zh-CN" },
                    { name : "Chinese Traditional", icon : null, value : "zh-TW" },
                    { name : "Croatian", icon : null, value : "hr" },
                    { name : "Czech", icon : null, value : "cs" },
                    { name : "Danish", icon : null, value : "da" },
                    { name : "Dutch", icon : null, value : "nl" },
                    { name : "English", icon : null, value : "en" },
                    { name : "Estonian", icon : null, value : "et" },
                    { name : "Finnish", icon : null, value : "fi" },
                    { name : "French", icon : null, value : "fr" },
                    { name : "German", icon : null, value : "de" },
                    { name : "Greek", icon : null, value : "el" },
                    { name : "Hebrew", icon : null, value : "iw" },
                    { name : "Hungarian", icon : null, value : "hu" },
                    { name : "Icelandic", icon : null, value : "is" },
                    { name : "Indonesian", icon : null, value : "id" },
                    { name : "Italian", icon : null, value : "it" },
                    { name : "Japanese", icon : null, value : "ja" },
                    { name : "Korean", icon : null, value : "ko" },
                    { name : "Latvian", icon : null, value : "lv" },
                    { name : "Lithuanian", icon : null, value : "lt" },
                    { name : "Norwegian", icon : null, value : "no" },
                    { name : "Polish", icon : null, value : "pl" },
                    { name : "Portuguese", icon : null, value : "pt" },
                    { name : "Romanian", icon : null, value : "ro" },
                    { name : "Russian", icon : null, value : "ru" },
                    { name : "Serbian", icon : null, value : "sr" },
                    { name : "Slovak", icon : null, value : "sk" },
                    { name : "Slovenian", icon : null, value : "sl" },
                    { name : "Spanish", icon : null, value : "es" },
                    { name : "Swedish", icon : null, value : "sv" },
                    { name : "Turkish", icon : null, value : "tr" }
                ],
                noneOfTheseWords: '',
                search: '',
                searchPlaceholder: 'Search web',
                searchTerm: '',
                site: '',
                thisExactPhrase: '',
                updatedAt: null,
                updatedAtValues: [
                    { name : 'anytime', icon: null, value : null },
                    { name : 'past 24 hours', icon: null, value : 'd' },
                    { name : 'past week', icon: null, value : 'w' },
                    { name : 'past month', icon: null, value : 'm' },
                    { name : 'past year', icon: null, value : 'y' }
                ],
                activeTags: [],
            }
        },
        methods: {
            getQueryParam: function (name, url) {
                if (!url) url = location.href;

                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");

                let regexS = "[\\?&]"+name+"=([^&#]*)";
                let regex = new RegExp(regexS);
                let results = regex.exec(url);
                return results == null ? null : results[1];
            },
            init: function () {
                /*(function() {
                    var cx = '009275257355941826566:spomlbkmlfa';
                    var gcse = document.createElement('script');
                    gcse.type = 'text/javascript';
                    gcse.async = true;
                    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(gcse, s);
                })();*/
                (function() {
                    var cx = '011709633724337717639:cty_ncq8qou';//partner-pub-5266706532383493:ejasi992zwz
                    var gcse = document.createElement('script');
                    gcse.type = 'text/javascript';
                    gcse.async = true;
                    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(gcse, s);
                    window.__gcse || (window.__gcse = {});
                    /*window.__gcse.searchCallbacks = {
                        web: {
                            rendered: function(name, q, promos, results) {
                                for (const div of promos.concat(results)) {
                                    var css = '<style type="text/css">' +
                                              'a.styleable-title { text-decoration: none !important; font-weight: normal; font-size: small; font-size: 20px; line-height: 26px; font-weight: 400; } a.styleable-title:hover { text-decoration: underline !important; } ' +
                                              '</style>';
                                    div.innerHTML = div.innerHTML+css;
                                    break;
                                }
                            },
                        },
                    };*/
                })();

                //this.search = this.getQueryParam('q');
                /*
                setTimeout(function() {
                    this.updateSearchResults()
                }.bind(this), 1000);
                */
            },
            scrollToResults: function () {
                let resultsElement = document.getElementById('search-results');
                if (resultsElement) {
                    resultsElement.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    });
                }
            },
            updateSearchResults(queryObj) {
                eventBus.$emit('show-loader');

                let arr = [];
                let i = 0;
                let j = 0;

                this.search = queryObj && queryObj.q ? queryObj.q : this.getQueryParam('q');
                if (this.search)
                    this.search = decodeURIComponent(this.search.replace(/\+/g,  " "));

                let str = queryObj && queryObj.country ? queryObj.country : this.getQueryParam('country');
                if (str) {
                    arr = str.split(',');
                    this.country = [];
                    for (i = 0; i < arr.length; i++)
                        for (j = 0; j < this.countries.length; j++)
                            if (arr[i] == this.countries[j].value) {
                                this.country.push(this.countries[j]);
                                break;
                            }
                }

                str = queryObj && queryObj.language ? queryObj.language : this.getQueryParam('language');
                if (str) {
                    arr = str.split(',');
                    this.language = [];
                    for (i = 0; i < arr.length; i++)
                        for (j = 0; j < this.languages.length; j++)
                            if (arr[i] == this.languages[j].value) {
                                this.language.push(this.languages[j]);
                                break;
                            }
                }

                str = queryObj && queryObj.filetype ? queryObj.filetype : this.getQueryParam('filetype');
                if (str) {
                    arr = str.split(',');
                    this.filetype = [];
                    let ftProps = Object.keys(this.filetypes);
                    let p = 0;
                    let found = false;
                    for (i = 0; i < arr.length; i++) {
                        for (p = 0; p < ftProps.length; p++) {
                            found = false;
                            for (j = 0; j < this.filetypes[ftProps[p]].length; j++)
                                if (arr[i] == this.filetypes[ftProps[p]][j].value) {
                                    this.filetype.push(this.filetypes[ftProps[p]][j]);
                                    found = true;
                                    break;
                                }
                            if (found)
                                break;
                        }
                    }
                }
                
                str = queryObj && queryObj.filetypeSearch ? queryObj.filetypeSearch : this.getQueryParam('filetypeSearch');
                if (str && str !== '')
                    this.filetypeSearch = str;
                    
                str = queryObj && queryObj.updatedAt ? queryObj.updatedAt : this.getQueryParam('updatedAt');
                if (str) {
                    for (j = 0; j < this.updatedAtValues.length; j++)
                        if (str == this.updatedAtValues[j].value) {
                            this.updatedAt = this.updatedAtValues[j];
                            break;
                        }
                }

                str = queryObj && queryObj.site ? queryObj.site : this.getQueryParam('site');
                if (str && str !== '')
                    this.site = str;

                str = queryObj && queryObj.allTheseWords ? queryObj.allTheseWords : this.getQueryParam('allTheseWords');
                if (str && str !== '')
                    this.allTheseWords = str;

                str = queryObj && queryObj.thisExactPhrase ? queryObj.thisExactPhrase : this.getQueryParam('thisExactPhrase');
                if (str && str !== '')
                    this.thisExactPhrase = str;

                str = queryObj && queryObj.anyOfTheseWords ? queryObj.anyOfTheseWords : this.getQueryParam('anyOfTheseWords');
                if (str && str !== '')
                    this.anyOfTheseWords = str;

                str = queryObj && queryObj.noneOfTheseWords ? queryObj.noneOfTheseWords : this.getQueryParam('noneOfTheseWords');
                if (str && str !== '')
                    this.noneOfTheseWords = str;
                
                
                let searchTerm = '';
                let options = '';
                
                if (this.country) {
                    let countrySearchTerm = '';
                    for (i = 0; i < this.country.length; i++)
                        countrySearchTerm += (i > 0 ? " OR" : "") + " site:" + this.country[i].value;
                    searchTerm += " " + countrySearchTerm;
                }
                if (this.language) {
                    let languageSearchTerm = '';
                    for (i = 0; i < this.language.length; i++)
                        //options += ' lr="lang_' + this.language.value + '"';
                        languageSearchTerm += (i > 0 ? " OR" : "") + " lang:" + this.language[i].value;
                    searchTerm += " " + languageSearchTerm;
                }
                if (this.filetypeSearch || this.filetype) {
                    let filetypeArr = this.filetypeSearch.split(',');
                    let filetypeSearchTerm = '';

                    for (i = 0; i < filetypeArr.length; i++)
                        if (filetypeArr[i] != '')
                            filetypeSearchTerm += (i > 0 ? " OR filetype:" : "filetype:") + " " + filetypeArr[i];

                    if (this.filetype)
                        for (i = 0; i < this.filetype.length; i++)
                            filetypeSearchTerm += ((i > 0 || (i == 0 && this.filetypeSearch != '')) ? " OR" : "") + " filetype:" + this.filetype[i].value;

                    searchTerm += " " + filetypeSearchTerm;
                }

                if (this.updatedAt && this.updatedAt.value)
                    options += ' as_qdr="' + this.updatedAt.value + '"';

                if (this.site != '')
                    options += ' as_sitesearch="' + this.site + '"';

                if (this.allTheseWords != '')
                    searchTerm += ' ' + this.allTheseWords;

                if (this.thisExactPhrase != '')
                    searchTerm += ' "' + this.thisExactPhrase + '"';

                if (this.anyOfTheseWords != '')
                    searchTerm += ' ' + this.anyOfTheseWords.replace(/  +/g, ' ').replace(' ', ' OR ');

                if (this.noneOfTheseWords != '')
                    searchTerm += ' -' + this.noneOfTheseWords.replace(/  +/g, ' ').replace(' ', ' -');

                this.searchTerm = searchTerm;
                if (this.search == '' && this.searchTerm == '')
                    return;
                this.googleCustomSearchResults = '<gcse:searchresults-only gname="google-search-results" autoSearchOnLoad="false" ' + options + '><\/gcse:searchresults-only>';

                
                if (this.loadCounter < 10) {
                    setTimeout(function () {
                        try {
                            google.search.cse.element.go();
                            let element = google.search.cse.element.getElement('google-search-results');
                            element.execute(this.search + this.searchTerm);
                            this.loadCounter = 0;
                        }
                        catch (ex) {
                            eventBus.$emit('hide-loader');
                            setTimeout(function () {
                                this.updateSearchResults()
                            }.bind(this), 1000);
                            this.loadCounter++;
                            return;
                        }
                    }.bind(this), 1000);
                }
                
                eventBus.$emit('hide-loader');

                if (this.loadCounter > 0) {
                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors loading search result. Please try again!')
                    );
                }
                /*
                setTimeout(function () {
                    this.scrollToResults()
                }.bind(this), 1000);
                */
            }
        },
        props: {
            type: {
                default: null,
                type: String
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AdvancedSearch.vue